import { useGetCompanyWithMembers } from "../../pages/Profile/pages/Team/hooks/useGetCompanyWithMembers";
import { useMe } from "./useMe";

export function useIsGuest() {
	const { me } = useMe();

	const { data: companyWithMembers, isLoading: isLoadingCompanyWithMembers } = useGetCompanyWithMembers();

	return {
		isGuest: companyWithMembers?.adminIds?.includes(me?.id ?? ""),
		isLoading: isLoadingCompanyWithMembers,
	};
}
